import { Locale } from '../../modules/locale'

declare global {
  interface Window {
    ATL_JQ_PAGE_PROPS: any
  }
}

export const initJiraIssueCollector = () => {
  let url = ''

  if (Locale.language === 'en') {
    url =
      'https://lavitrine.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/xghl7j/b/9/c95134bc67d3a521bb3f4331beb9b804/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-CA&collectorId=324f1c03'
  } else {
    url =
      'https://lavitrine.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/xghl7j/b/9/c95134bc67d3a521bb3f4331beb9b804/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=fr-CA&collectorId=aad30c9b'
  }

  const observer = new MutationObserver(() => {
    if (document.querySelector('#atlwdg-trigger')) {
      observer.disconnect()
      styleTriggerButton()
    }
  })
  observer.observe(document.body, { childList: true, subtree: true })

  let externalScript = document.createElement('script')
  externalScript.src = url
  externalScript.async = true
  externalScript.onload = handleMutationObserver
  document.body.appendChild(externalScript)
}

const styleTriggerButton = () => {
  const triggerButton = document.querySelector('#atlwdg-trigger') as HTMLElement
  if (triggerButton) {
    triggerButton.style.display = 'flex'
    triggerButton.style.alignItems = 'center'
    triggerButton.style.backgroundColor = '#FF4600'
    triggerButton.style.fontWeight = '400'
    triggerButton.style.border = 'none'
    triggerButton.style.padding = '0 20px'
    triggerButton.style.height = '38px'
    triggerButton.style.fontSize = '14px'
    triggerButton.style.zIndex = '999'
  }
}

const handleMutationObserver = () => {
  window.ATL_JQ_PAGE_PROPS = window.ATL_JQ_PAGE_PROPS || {}

  if (!window.ATL_JQ_PAGE_PROPS.fieldValues) {
    window.ATL_JQ_PAGE_PROPS.fieldValues = {
      summary: 'Feedback',
    }
  } else {
    window.ATL_JQ_PAGE_PROPS.fieldValues.summary = 'Feedback'
  }
}
